import { useSelector } from "react-redux";

function useWhatsApp() {
  return useSelector(state => state.whatsApp);
}

export default useWhatsApp;
